import * as React from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';

import {
  StoreCardActions,
  StoreCardDetails,
  StoreCardError,
  StoreCardSeperator,
} from './components';
import { StoreCaption } from './store-caption';
import { CardButton, FadeIn } from './store-card.styled';
import { StoreCardViewProps } from './types';

export const StoreCardView: React.FC<StoreCardViewProps> = ({
  isFavorite = false,
  isUpdatingFavorites = false,
  onCardClick,
  onDiagnosticsClick,
  onFavoriteClick,
  storeDetails,
}) => {
  const { formatMessage } = useIntl();

  return (
    <FadeIn>
      <Box
        background={Styles.color.cardBackground}
        padding="0.5rem 0.75rem"
        justify="space-between"
        align="center"
        position="relative"
        overflow="hidden"
        minHeight="96px"
      >
        {onCardClick && (
          <CardButton
            data-testid="store-card-button"
            aria-label={`
              ${storeDetails.title?.toLowerCase()}. ${formatMessage({ id: 'openAccordion' })}
            `}
            onClick={onCardClick}
          />
        )}
        <StoreCardDetails
          title={storeDetails.title}
          caption={<StoreCaption storeDetails={storeDetails} />}
          body={storeDetails.body}
          errorMessage={
            storeDetails.errorMessage ? (
              <StoreCardError message={storeDetails.errorMessage} />
            ) : null
          }
          inStoreLoyalty={storeDetails.inStoreLoyalty}
          mobileLoyalty={storeDetails.mobileLoyalty}
        />

        <StoreCardSeperator />

        <Box minWidth="fit-content" width="fit-content" zIndex="1">
          <StoreCardActions
            favoriteIcon={isFavorite}
            onDiagnosticsClick={onDiagnosticsClick}
            onFavoritesClick={onFavoriteClick}
            isUpdatingFavorites={isUpdatingFavorites}
          />
        </Box>
      </Box>
    </FadeIn>
  );
};
